import { withStyles } from "@material-ui/core";

const styles = (theme) => ({
  detail: {
    display: "flex",
    alignItems: "center",
    fontSize: theme.textFontSize,
    margin: "6px 0px 6px",
  },
  label: {
    color: theme.printTableLabel,
    fontWeight: 600,
    lineHeight: "16px",
    marginRight: 12,
  },
  value: {
    color: theme.printTableLabel,
    fontWeight: 700,
    lineHeight: "16px",
    marginRight: 4,
  },
});

const SummaryItem = ({ classes, label, value }) => {
  return (
    <div className={classes.detail}>
      <span className={classes.value}>{value}</span>
      <span className={classes.label}>{label}</span>
    </div>
  );
};

export default withStyles(styles)(SummaryItem);
